"use client";

import { useIsDesktop } from "@/hooks/useIsDesktop";

const URB = "var(--font-urbanist), sans-serif";

export default function ThinkingIndicator({ label = "Analyzing your request…" }: { label?: string }) {
  const isDesktop = useIsDesktop();
  return (
    <div
      className="app-anim-fade-left"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "6px 0",
      }}
    >
      {isDesktop ? (
        <img
          src="/app-icons/robot.svg"
          alt=""
          className="app-loading-pulse app-anim-float"
          style={{ width: 26, height: 26 }}
        />
      ) : (
        <img
          src="/app-icons/robot.svg"
          alt=""
          className="app-loading-pulse"
          style={{ width: 32, height: 32 }}
        />
      )}
      <span
        style={{
          fontFamily: URB,
          fontWeight: 500,
          fontSize: 14,
          lineHeight: "20px",
          color: "rgba(242,240,237,0.7)",
        }}
      >
        {label}
      </span>
    </div>
  );
}
